import { store } from "../redux/store";
import { userLoggedIn, setSession } from "../redux/actions/auth";
import {
    setLoggedInOrRegisterComplete,
    setShowWhatsNew,
} from "../redux/actions/appStatus";
import { setUsername } from "../redux/actions/user";
import { LoginSession } from "../redux/models/loginSession";
import { downloadProfile } from "./profileService";
import { setCurrentUser } from "../redux/actions/currentUser";
import { addUserProfile } from "../redux/actions/addUserProfile";
import { getSubscriptions } from "./subscriptionService";
import { startAds } from "./AdMobService";
import { UserProfile } from "../models/userProfile";

export interface CompleteLoginOptions {
    session: LoginSession;
    email: string;
    isNewUser?: boolean;
    skipProfileDownload?: boolean;
}

/**
 * Consolidates all login completion logic into a single function.
 * Used by both password login (login.tsx) and magic link (AppUrlListener.tsx).
 */
export async function completeLogin(
    options: CompleteLoginOptions
): Promise<void> {
    const { session, email, isNewUser, skipProfileDownload } = options;
    const dispatch = store.dispatch;

    // Core auth state - always set these
    dispatch(setSession(session));
    dispatch(userLoggedIn(true, session));
    dispatch(setUsername(email));

    if (!isNewUser) {
        dispatch(setLoggedInOrRegisterComplete(true));
        dispatch(setShowWhatsNew(true));

        // Download profile unless skipped
        if (!skipProfileDownload) {
            try {
                const userId = session.user_id;
                const response = await downloadProfile(userId);
                const profile = response.data as UserProfile;
                dispatch(setCurrentUser(profile));
                dispatch(addUserProfile(profile));
                await getSubscriptions().catch(() => {});
            } catch (e) {
                console.log("Failed to download profile on login", e);
            }
        }

        startAds();
    }
}
